import React, { useMemo } from "react";
import SubProjectsMap from "../../../../SubProjectsMap";
import { useSubProjects } from "../../../../../hooks/useProcuringEntity";
import { Button } from "antd";
import Loader from "../../Loader";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";

function PackageMap({ match }) {
  const history = useHistory();
  const {
    params: { packageId },
  } = match;
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";
  const filterObj = useMemo(
    () => ({ "filter[procuring_entity_package_id]": packageId }),
    [packageId]
  );

  const { subProjects, loading } = useSubProjects(filterObj);
  if (loading) {
    return <Loader fontSize={18} flexDirection="column" />;
  }
  return (
    <div style={{ padding: "1rem" }}>
      <ActionBar
        actionButtonProp={{
          title: `${packageName || "==//=="}: Geo-referenced Subproject progress updates`,
        }}
      />
      <SubProjectsMap subProjects={subProjects?.data || []} />
    </div>
  ); 
} 

export default PackageMap;
